import React from 'react';
import { StorageAdapter } from '../utils/StorageAdapter.ts';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import LeftNavRoot from './LeftNavRoot.react.js';
import Link from 'react-router/lib/Link';
import OrganisationChooser from '../organisations/OrganisationChooser.react';
import * as Permission from '../../common/util/Permission';

import '../app/init.scss';
import './App.scss';
import '../view/Panels.scss';
import './callout.scss';
// import 'bootstrap';
import types from '../../common/model-api/types';

import Header from './Header.react';

import urlMapping from '../app/URLMapping';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import {detect} from 'detect-browser';

import {sendToExtension, onClickExtensionInstall, getExtensionURL, setExtensionPresent} from './ExtensionCommunicate';
import {onSignOutClick, getProfile} from './auth.js';
import {setErrorUserContext, sendError} from './errorDisplayer';

import EventTracker from './EventTracker';
//import Intercom from 'react-intercom';
import * as FeatureFlags from '../../common/util/FeatureFlags.ts';
import {sendToken} from '../app/SignIn.react';
import ScenarioPrerequisite from '../scenarios/ScenarioPrerequisite.react';
import AutoCreateOrganisationMutation from '../home/AutoCreateOrganisationMutation';
import LastOrganisationId, {getLastOrganisationId} from '../app/LastOrganisationId';
import * as BrowserPermission from '../BrowserPermission';
import { getUISettings, isAddonMode } from './UISettings.react.js';
import { User } from '../../common/types/types';
import Announcement from '../../common/types/types.ts';
import AnnouncementBox from '../announcements/AnnouncementBox.react';
import AnnouncementLine from '../announcements/AnnouncementLine.react';
import { ANNOUNCEMENTS_TYPE_TOP_LINE, ANNOUNCEMENTS_TYPE_TOP_LINE_WARNING, ANNOUNCEMENTS_TYPE_POPUP } from '../../common/model-api/AnnouncementsType';
import MarkAsReadMutation from '../announcements/MarkAsReadMutation.react.js';

export const messages = defineMessages({
    missingExtension: {id: 'extension.missing.popupTitle', 'defaultMessage': 'Install browser extension'},
    popupDescription: {id: 'extension.missing.popupDescription', 'defaultMessage': 'To fully use {productName}, please install Browser Extension.'},
    unsupportedBrowserTitle: {id: 'extension.missing.unsupportedBrowserTitle', 'defaultMessage': 'Unsupported browser'},
    unsupportedBrowser: {id: 'extension.missing.unsupportedBrowser', 'defaultMessage': 'To fully use {productName}, you need to use supported browser and install Browser Extension.'},
    support: {id: 'footer.support', 'defaultMessage': 'Support'},
    termsOfService: {id: 'footer.termsOfService', 'defaultMessage': 'Terms of Service'},
});

interface AppProps {
 children?: React.ReactNode;
 intl: IntlShape;
 organisationId?: string;
 params?: object;
 relay?: object;
 routes?: unknown[];
 user: User;
}

class App extends React.PureComponent<AppProps> {

    static propTypes = {
        children: PropTypes.node,
        intl: PropTypes.object.isRequired,
        organisationId: PropTypes.string,
        params: PropTypes.object,
        relay: PropTypes.object,
        routes: PropTypes.array,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.setOrganisation();
        this.state = {
            userLogged: false,
            hasTopLine: false,
            missingExtension: false,
            leftMenuExpanded: false,
            organisation: undefined,
            developerMode: BrowserPermission.getViewMode() === BrowserPermission.VIEW_MODE_DEVELOPER,
        };

        const browser = detect();
        this.browserName = browser.name;
        document.body.parentElement.classList.add(this.browserName);
    }

    componentWillReceiveProps(props) {
        EventTracker.initEventTracker(props.user);

        let newOrgs = props.user.organisations.edges.map(org => org.node.realId).sort();
        let prevOrgs = this.props.user.organisations.edges.map(org => org.node.realId).sort();

        if (this.state.organisation && props.organisationId && props.organisationId !== this.state.organisation.realId) {
            this.setOrganisation();
        }
        else if (newOrgs.length !== prevOrgs.length) {
            this.setOrganisation();
        }
        else {
            for (let i = 0; i < newOrgs.length; i++) {
                if (newOrgs[i] !== prevOrgs[i]) {
                    this.setOrganisation();
                    break;
                }
            }
        }

        if (this.state.organisation && this.state.organisation.name && props.user.organisation && this.state.organisation.realId === props.user.organisation.realId && this.state.organisation.name !== props.user.organisation.name) {
            let org = this.state.organisation;
            org.name = props.user.organisation.name;

            this.setState({
                organisation: org
            });
        }
    }

    setOrganisation() {
        setTimeout(async () => {
            let org = await this.getOrganisation();

            if (org && !this.state.organisation || org.realId !== this.state.organisation.realId) {
                if (!this.isInAdminMode()) {
                    this.setState({
                        organisation: org
                    });
                }

                StorageAdapter.setSync('lastFocusOrg', org.realId);

            }
        });
    }

    chooseOrganisation(org) {
        this.setState({
            organisation: org
        });
        StorageAdapter.setSync('lastFocusOrg', org.realId);

        LastOrganisationId.set(org.realId, this.props.relay);
    }

    async getOrganisation() {
        let organisation;
        let lastOrganisationId = ScenarioPrerequisite.getStoredOrganisation();

        if (lastOrganisationId) {
            let organisationNode = this.props.user.organisations.edges.find(({node}) => node.realId === lastOrganisationId);

            if (organisationNode) {
                organisation = organisationNode.node;
            }
        }

        if (this.props.user.organisation && this.props.user.organisation.realId) {
            organisation = this.props.user.organisation;
        }

        lastOrganisationId = LastOrganisationId.get();
        if (!organisation && lastOrganisationId) {
            let organisationNode = this.props.user.organisations.edges.find(({node}) => node.realId === lastOrganisationId);

            if (organisationNode) {
                organisation = organisationNode.node;
            }
            else {
                LastOrganisationId.clear();
            }
        }

        if (!organisation) {
            this.props.user.organisations.edges.sort((itemA, itemB) => itemA.node.name.localeCompare(itemB.node.nme));

            if (this.props.user.organisations && this.props.user.organisations.edges && this.props.user.organisations.edges.length > 0) {
                organisation = this.props.user.organisations.edges[0].node;
                lastOrganisationId = organisation.realId;
            }
            else {
                lastOrganisationId = await this.autoCreateOrganisation();
                organisation = this.props.user.organisations.edges.find(({node}) => node.realId === lastOrganisationId);
            }
        }

        LastOrganisationId.set(lastOrganisationId, this.props.relay);

        return organisation;
    }

    isInAdminMode() {
        if (this.state.organisation && this.state.organisation.realId) {
            let hasOrg = this.props.user.organisations.edges.findIndex(({node}) => node.realId === this.state.organisation.realId);
            /* in admin mode, we get organisation that is not read from our organisation list */
            if (hasOrg === -1) {
                return true;
            }
        }

        return false;
    }

    async autoCreateOrganisation() {
        return new Promise((resolve, reject) => {
            let onFailure = () => {
                // nothing for now
                resolve();
            };

            let onSuccess = (result) => {
                LastOrganisationId.set(result.autoCreateOrganisation.organisationId);
                resolve(result.autoCreateOrganisation.organisationId);
            };

            Relay.Store.commitUpdate(new AutoCreateOrganisationMutation(), {
                onFailure,
                onSuccess
            });
        });
    }

    installExtension() {
        this.setState({missingExtension: false}); // hide info about missing extension
        return onClickExtensionInstall().then((result) => {
            if (!result) {
                window.location = getExtensionURL();
            }
        });
    }

    async checkForExtension() {
        return sendToExtension({
            message: 'dativery-version'
        }).then(response => {
            if (response) {
                setExtensionPresent(true);
                this.setState({
                    'missingExtension': false
                });
            }
            return Boolean(response);
        }).catch((e) => {
            sendError(e);
        });
    }

    extensionIsMissing() {
        setExtensionPresent(false);
        this.setState({
            'missingExtension': true
        });

        this.checkForExtension().then(isExtensioon => {
            if (!isExtensioon) {
                let interval = setInterval(() => {
                    this.checkForExtension().then(isExtensioon => {
                        if (isExtensioon) {
                            clearInterval(interval);
                        }
                    }).catch((e) => {
                        sendError(e);
                    });

                    return true;
                }, 10000);
            }
        }).catch((e) => {
            sendError(e);
        });
    }

    componentDidMount() {
        window.addEventListener("focus", () => {
            if (this.state.organisation && this.state.organisation.realId) {
                LastOrganisationId.store(this.state.organisation.realId);
            }
        }, false);

        sendToExtension({
            message: 'dativery-version'
        }).then(response => {
            if (!response) {
                let org = this.state.organisation;
                if (org && (!('requiresBrowserExtension' in org) || org.requiresBrowserExtension === null || typeof (org.requiresBrowserExtension) === "undefined" || org.requiresBrowserExtension === true)) {
                    this.extensionIsMissing();
                }
            } else if ('logged' in response && !response.logged) {
                /* extension is present but not logged - send token */
                sendToken();
            }
        }).catch((e) => {
            sendError(e);
        });
        document.documentElement.classList.add('dativery-admin');
    }

    componentWillMount() {
        getProfile().then((profile) => {
            // Success callback
            this.setState({'userLogged': true, 'profile': profile});
            setErrorUserContext(profile);
        }).catch((e) => {
            sendError(e);
        });
    }

    userProfile() {
        if (this.state.userLogged) {
            let menu = [];
            let idx = 0;
            menu.push(<li key={idx++}><Link to="/settings/"><i aria-hidden="true" className="fa fa-fw fa-cog"></i>&nbsp; <FormattedMessage defaultMessage="My Profile" id="main.myProfile" /></Link></li>);
            if (this.state.organisation) {
                menu.push(<li key={idx++}><Link activeClassName="active" to={urlMapping.getUrl(types['organisations'], 'edit', this.state.organisation)}><i aria-hidden="true" className="fa fa-fw fa-list"></i>&nbsp; <FormattedMessage defaultMessage="Billing information" id="organisation.editBilling" /></Link></li>);
            }
            menu.push(<li className="divider" key={idx++} role="separator" ></li>);

            const isDeveloper = BrowserPermission.isDeveloper();

            if (this.state.organisation && FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_ENABLE_CACHING, this.props.user) && isDeveloper) {
                menu.push(<li key={idx++}><Link activeClassName="active" to={urlMapping.getUrl(types['jobs'], 'list', this.state.organisation)}><i aria-hidden="true" className="fa fa-fw fa-list"></i>&nbsp; <FormattedMessage defaultMessage="Jobs" id="jobs.list" /></Link></li>);
            }

            menu.push(<li key={idx++}><Link activeClassName="active" to={urlMapping.getUrl(types['channelErrors'], 'list-user-type', {id: this.props.user.id})}><i aria-hidden="true" className="fa fa-fw fa-exclamation-circle"></i>&nbsp; <FormattedMessage defaultMessage="Errors" id="ChannelErrors.list" /></Link></li>);

            if (this.state.organisation && BrowserPermission.hasPermission(Permission.PERM_INSTANCE_SUPPORT)) {
                menu.push(<li key={idx++}><Link activeClassName="active" to={urlMapping.getUrl(types['organisationNotifications'], 'list', this.state.organisation)}><i aria-hidden="true" className="fa fa-fw fa-comment"></i>&nbsp; <FormattedMessage defaultMessage="Notifications" id="OrganisationNotifications.list" /></Link></li>);
            }

            if (BrowserPermission.hasPermission(Permission.PERM_INSTANCE_SUPPORT) && isDeveloper) {
                menu.push(<li className="divider" key={idx++} role="separator" ></li>);
                menu.push(<li key={idx++}><Link activeClassName="active" to={urlMapping.getUrl(types['channelErrors'], 'list-consultant-fail', {id: this.props.user.id})}><i aria-hidden="true" className="fa fa-fw fa-exclamation-circle"></i>&nbsp; <FormattedMessage defaultMessage="Errors for consultant" id="ChannelErrors.listForConsultant" /></Link></li>);
                menu.push(<li key={idx++}><Link activeClassName="active" to={urlMapping.getUrl(types['organisationNotifications'], 'list-consultant', {id: this.props.user.id})}><i aria-hidden="true" className="fa fa-fw fa-comment"></i>&nbsp; <FormattedMessage defaultMessage="Notifications for consultant" id="OrganisationNotifications.listForConsultant" /></Link></li>);
            }

            menu.push(<li className="divider" key={idx++} role="separator" ></li>);

            menu.push(<li key={idx++}><a href="#" onClick={onSignOutClick}><i aria-hidden="true" className="fa fa-fw fa-sign-out"></i>&nbsp; <FormattedMessage defaultMessage="Log Out" id="logout2" /></a></li>);

            return (
                <li className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                        <span className="layout-large">{this.state.profile ? <span><img className="profilePicture" src={this.state.profile.picture}/> {this.state.profile.name}</span> : <i className="fa fa-user-o"></i>}</span>
                        <i className="fa fa-user-o layout-small"></i>
                        <span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu" role="menu">
                        {menu}
                    </ul>
                </li>
            );
        } else {
            return (<span></span>);
        }
    }

    toggleLeftMenu() {
        this.setState({
            leftMenuExpanded: !this.state.leftMenuExpanded
        });
    }
    toggleViewMode(type) {
        BrowserPermission.toggleViewMode(type);
        this.forceUpdate();
    }
    getViewMode() {
        return BrowserPermission.getViewMode();
    }

    markAsRead(announcement: Announcement, type: string) {
        console.error("markAsRead", announcement, type);
        return new Promise((resolve, reject) => {
            let onFailure = () => {
                // nothing for now
                resolve();
            };

            let onSuccess = (result) => {
                resolve();
            };

            Relay.Store.commitUpdate(new MarkAsReadMutation({announcement_id: announcement.realId, type}), {
                onFailure,
                onSuccess
            });
        });
    }

    render() {
        const { user } = this.props;
        const uiSettings = getUISettings();

        if (!this.state.organisation) {
            return null;
        }

        const addonMode = isAddonMode();

        // If hideMenu or addon mode is true, show only content without menu and navigation
        if (uiSettings.hideMenu || addonMode) {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="content">
                            {this.props.children}
                        </div>
                    </div>
                    {addonMode && (
                        <footer className="addon-footer">
                            <div className="footer-links">
                                <a href="https://www.dativery.com" target="_blank" rel="noopener noreferrer">www.dativery.com</a>
                                <span className="separator">|</span>
                                <a href="https://www.dativery.com/cs/support/" target="_blank" rel="noopener noreferrer"><FormattedMessage {...messages.support} /></a>
                                <span className="separator">|</span>
                                <a href="https://www.dativery.com/cs/terms/" target="_blank" rel="noopener noreferrer"><FormattedMessage {...messages.termsOfService} /></a>
                            </div>
                        </footer>
                    )}
                </div>
            );
        }


        let validAnnouncements = user.validAnnouncements.edges.map(({node}) => node);
        validAnnouncements = validAnnouncements.filter((item) => {
               // Check if user has dismissed this before
            if (StorageAdapter.getSync("box-" + item.realId) === "true") {
                return false;
            }


            return true;
        });

        let topLineAnnouncement = validAnnouncements.filter((item) => {
            return item.announcementType === ANNOUNCEMENTS_TYPE_TOP_LINE || item.announcementType === ANNOUNCEMENTS_TYPE_TOP_LINE_WARNING;
        });
        let popupAnnouncement = validAnnouncements.filter((item) => {
            return item.announcementType === ANNOUNCEMENTS_TYPE_POPUP;
        });

        let popup;
        if (popupAnnouncement.length > 0) {
            popup = popupAnnouncement[0];
        }

        let topLine;
        if (topLineAnnouncement.length > 0) {
            topLine = topLineAnnouncement[0];
        }
        
        if (topLine) {
            if (!this.state.hasTopLine) {
                this.setState({hasTopLine: true});
            }
        } else {
            if (this.state.hasTopLine) {
                this.setState({hasTopLine: false});
            }
        }



        const isDeveloper = BrowserPermission.isDeveloper();
        const isPartner2 = BrowserPermission.isPartner2();
        const isPartner1 = BrowserPermission.isPartner1();

        return (
            <div>
                <nav className="navbar navbar-fixed-top">
                    {this.state.hasTopLine ? <AnnouncementLine title={topLine.title} message={topLine.body} icon={topLine.icon} ctaText={topLine.linkText} ctaUrl={topLine.link} isWarning={topLine.announcementType === ANNOUNCEMENTS_TYPE_TOP_LINE_WARNING} onClose={() => {
                        this.markAsRead(topLine, 'close');
                        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                            event: 'announcement-close',
                            type: 'announcements',
                            'announcementId': topLine.realId,
                        });
                        this.setState({hasTopLine: false});
                        StorageAdapter.setSync("box-" + topLine.realId, "true");

                    }} onClick={() => {
                        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                            event: 'announcement-click',
                            type: 'announcements',
                            'announcementId': topLine.realId,
                        });
                        this.setState({hasTopLine: false});
                        return this.markAsRead(topLine, 'click');
                    }} /> : null}

                    <Header
                        developerMode={this.state.developerMode}
                        getViewMode={() => this.getViewMode()}
                        installExtension={() => this.installExtension()}
                        missingExtension={this.state.missingExtension}
                        orgChooser={(
                            <OrganisationChooser chooseOrganisation={(org) => {this.chooseOrganisation(org);}} currentOrganisation={this.state.organisation} organisations={this.props.user.organisations.edges.map(({node}) => node)}/>
                        )}
                        organisation={this.state.organisation}
                        toggleLeftMenu={() => this.toggleLeftMenu()}
                        toggleViewMode={(type) => this.toggleViewMode(type)}
                        userProfile={this.userProfile()}
                    />
                </nav>
                
                {popup ? <AnnouncementBox title={popup.title} message={popup.body} icon={popup.icon} ctaText={popup.linkText} ctaUrl={popup.link} onClose={() => {
                        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                            event: 'announcement-close',
                            type: 'announcements',
                            'announcementId': popup.realId,
                        });

                        this.markAsRead(popup, 'close');
                        StorageAdapter.setSync("box-" + popup.realId, "true");
                }} onClick={() => {
                    EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                        event: 'announcement-click',
                        type: 'announcements',
                        'announcementId': popup.realId,
                    });

                    return this.markAsRead(popup, 'click');
                }} /> : null}

                <div className={"container-fluid " + (this.state.hasTopLine ? "hasTopLine" : "noTopLine")}>
                    {/*this.state.userLogged && config.isProduction ? <Intercom appID={config.INTERCOM_APP_ID} {...this.state.profile} language_override={getLocale()} /> : null*/}
                    <div className="row">
                        <div className={"sidebar " + (this.state.leftMenuExpanded ? 'leftMenuShow' : '')}>
                            <LeftNavRoot currentOrganisation={this.state.organisation} toggleLeftMenu={() => this.toggleLeftMenu()} user={user} />
                        </div>
                        <div className="mainContent">
                            {this.isInAdminMode() && (isDeveloper || isPartner1 || isPartner2) ? <div className="admin-mode"><FormattedMessage defaultMessage="Admin mode" id="adminMode" /></div> : null}
                            <div className="content">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Relay.createContainer(injectIntl(App), {
    initialVariables: {
        organisationId: '',
        organisationSelected: false,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        variables['organisationSelected'] = variables['organisationId'] ? true : false;
        return variables;
    },

    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                firstname,
                surname,
                instance {
                    id,
                    realId,
                    name,

                },
                ${EventTracker.getFragment()}
                email,
                organisation(id: $organisationId) @include(if: $organisationSelected) {
                    id,
                    realId,
                    name
                    featureFlags,
                    requiresBrowserExtension,
                    ${OrganisationChooser.getFragment('organisations')}
                },
                validAnnouncements(first: 20) {
                    edges {
                        node {
                            id,
                            realId,
                            title,
                            body,
                            icon,
                            link,
                            linkText,
                            announcementType,
                        }
                    }
                },
                organisations(first: 10000) {
                    edges {
                        node {
                            id,
                            realId,
                            name
                            featureFlags,
                            requiresBrowserExtension,
                            ${OrganisationChooser.getFragment('organisations')}
                        }
                    }
                }
                ${LeftNavRoot.getFragment('user')}
            }
        `,
    },
});
